import { createSlice } from "@reduxjs/toolkit";

const authenticationSlice = createSlice({
  name: "authentication",
  initialState: {
    edgePin: "",
    pincodeEnabled: false,
    pinUnlocked: false,
  },
  reducers: {
    setEdgePin: (state, action) => {
      state.edgePin = action.payload;
    },
    clearEdgePin: (state) => {
      state.edgePin = "";
      state.pinUnlocked = false;
    },
    setPincodeEnabled: (state, action) => {
      state.pincodeEnabled = action.payload;
    },
    setPinUnlocked: (state, action) => {
      state.pinUnlocked = action.payload;
    },
  },
});

export const { setEdgePin, clearEdgePin, setPincodeEnabled, setPinUnlocked } = authenticationSlice.actions;

export const selectEdgePin = (state) => state.authentication.edgePin;
export const selectPincodeEnabled = (state) => state.authentication.pincodeEnabled;
export const selectPinUnlocked = (state) => state.authentication.pinUnlocked;

export default authenticationSlice.reducer;
